import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import TimePicker from 'react-time-picker'

import {FaDownload} from 'react-icons/fa'
import {ThemeProvider} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

import { appTheme , parseTimestamp} from '../../../utils'

import {
    CREATE_STATE,
    CREATE_SUCCESS_STATE,
    UPDATE_SUCCESS_STATE,
    DELETED_STATE
} from '../../../constants'


class EventDisplay extends Component {

    constructor(props){
        super(props)
        this.getErrorMessagesStr = this.getErrorMessagesStr.bind(this)
    }

    getErrorMessagesStr(errorMessages){
        if (errorMessages.invalidClientId){
            return 'El ID del cliente es invalido'
        }
        if (errorMessages.invalidClientMail){
            return 'El correo electronico es invalido'
        }
        if (errorMessages.invalidName){
            return 'El nombre del fallecido es invalido'
        }
        if (errorMessages.invalidRoom){
            return 'Escoja una sala valida'
        }
        if (errorMessages.invalidTimeRange){
            return 'El rango de horas es invalido'
        }
        if (errorMessages.invalidReservedSpaces){
            return 'El valor de espacios reservados debe ser un numero'
        }
        return ''
    }

    getXLSData(reservations){
        var rows = []
        const headers = [
            'ID',
            'Nombre',
            'Telefono',
            'Correo',
            'Placa',
            'Invitados',
            'Productos',
            'Hora de llegada',
            'Silla de ruedas',
            'Acepta recibir info',
            'CheckIn'
        ]
        rows.push(headers)
        for (var reservationId in reservations){
            const reservation = reservations[reservationId]
            const guests = reservation.guests.map(el => el.name).filter(
                el => el.length > 0
            )
            const products = reservation.products ? reservation.products.map(el => el.name) : []
            var total = 0
            for (var product in reservation.products){
                total += reservation.products[product].value
            }
            products.push(`Total: ${total}`)

            const row = [
                reservationId,
                reservation.personalData.name,
                reservation.personalData.phone,
                reservation.personalData.mail,
                reservation.personalData.plate,
                guests.join('\n'),
                products.join('\n'),
                parseTimestamp(reservation.selectedTime).time,
                reservation.wheelChair ? 'Si' : 'No',
                reservation.mailInfo ? 'Si' : 'No',
                reservation.checkIn ? 'Si' : 'No'
            ]
            rows.push(row)

        }
        return rows
    }

    render(){
        const {
            eventData,
            eventId,
            availableRooms,
            errorMessages,
            eventsState,
            onEventChange,
            onSubmit,
            onReservationDownload,
            reservations,
            onDelete
        } = this.props
        const {getErrorMessagesStr, getXLSData} = this
        const eventDataErrorsStr = getErrorMessagesStr(errorMessages)
        const isCreate = [CREATE_STATE, CREATE_SUCCESS_STATE].includes(eventsState)
        const disabled = [CREATE_SUCCESS_STATE, UPDATE_SUCCESS_STATE, DELETED_STATE].includes(eventsState)
        var filteredAvailableRooms = {}
        for (var roomId in availableRooms){
            if (!availableRooms[roomId].available && (isCreate || eventData.room.id !== roomId)){
                continue
            }
            filteredAvailableRooms[roomId] = availableRooms[roomId]
        }
        const tableDataToXLS = getXLSData(reservations)
        return(
            <div className="display-block-container">
                <div className="line-header-text">{isCreate ? "Crear evento" : "Editar evento"}</div>
                <div className="event-display-container">
                    <div className="events-finder-search personal-data-block">
                        <table>
                                <tr>
                                    <th className="table-left">ID del cliente</th>
                                    <th className={errorMessages.invalidClientId ? "input-error-container" : "input-block"}>
                                    <div className="input-error">
                                        <input
                                            type="text"
                                            className="text-input"
                                            value={eventData.client_id}
                                            onChange={event => onEventChange('client_id', event.target.value)}
                                            placeholder="**cedula"
                                            disabled={disabled}
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Correo electronico</th>
                                    <th className={errorMessages.invalidClientMail ? "input-error-container" : "input-block"}>
                                    <div className="input-error">
                                        <input
                                            type="text"
                                            className="text-input"
                                            value={eventData.client_mail}
                                            onChange={event => onEventChange('client_mail', event.target.value)}
                                            disabled={disabled}
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Nombre del fallecido</th>
                                    <th className={errorMessages.invalidName ? "input-error-container" : "input-block"}>
                                    <div className="input-error">
                                        <input
                                            type="text"
                                            className="text-input"
                                            onChange={event => onEventChange('name', event.target.value)}
                                            value={eventData.name}
                                            disabled={disabled}
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Sala</th>
                                    <th >
                                        <select
                                            className="select-css select-css-small"
                                            disabled={disabled}
                                            value={eventData.room.id}
                                            onChange={event => onEventChange('room_id', event.target.value)}
                                        >
                                        {
                                            Object.keys(filteredAvailableRooms).map(key => {
                                                if (key !== 'all'){
                                                    return (
                                                        <option value={key} key={key}>{filteredAvailableRooms[key].name}</option>
                                                    )
                                                } else {
                                                    return (
                                                        <option value={key} key={key}>Escoja una opcion</option>
                                                    )
                                                }
                                            })
                                        }
                                        </select>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Reservar espacios</th>
                                    <th className={errorMessages.invalidReservedSpaces ? "input-error-container" : "input-block"}>
                                    <div className="input-error">
                                        <input
                                            type="text"
                                            className="text-input"
                                            disabled={disabled}
                                            value={eventData.reservedSpaces}
                                            onChange={event => onEventChange('reservedSpaces', event.target.value)}
                                        />
                                    </div>
                                    </th>
                                </tr>
                        </table>
                    </div>
                    <div className="events-finder-search personal-data-block">
                        <table>
                                <tr>
                                    <th className="table-left">Fecha inicio</th>
                                    <th className="table-left">
                                    <div>
                                        <DatePicker
                                        selected={eventData.start}
                                        disabled={disabled || !isCreate}
                                        onChange={value => onEventChange('startDate', value)}
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Hora Inicio</th>
                                    <th className="table-left">
                                    <div className="input-error">
                                        <TimePicker
                                            value={new Date(eventData.start)}
                                            disabled={disabled || !isCreate}
                                            clearIcon={null}
                                            clockIcon={null}
                                            onChange={value => onEventChange('startTime', value)}
                                            className="time-picker-style"
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Fecha final</th>
                                    <th className="table-left">
                                    <div>
                                        <DatePicker
                                        selected={eventData.end}
                                        disabled={disabled || !isCreate}
                                        onChange={value => onEventChange('endDate', value)}
                                        />
                                    </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th className="table-left">Hora Final</th>
                                    <th className="table-left">
                                    <div className="input-error">
                                        <TimePicker
                                            value={new Date(eventData.end)}
                                            required={true}
                                            disabled={disabled || !isCreate}
                                            clearIcon={null}
                                            clockIcon={null}
                                            onChange={value => onEventChange('endTime', value)}
                                            className="time-picker-style"
                                        />
                                    </div>
                                    </th>
                                </tr>
                        </table>
                        {
                            isCreate ?
                            <div></div> :
                            <div>
                                <div className="button-padding">
                                    <ThemeProvider theme={appTheme}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={onReservationDownload}
                                            size="small"
                                            disabled={false}
                                        >
                                            <FaDownload/> lista de invitados
                                        </Button>
                                    </ThemeProvider>
                                </div>
                                <div>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xls-button"
                                        className="download-table-xls-button"
                                        table="table-to-xls"
                                        filename="tablexls"
                                        sheet="tablexls"
                                        buttonText="Lista de invitados como XLS"/>
                                    <table id="table-to-xls" hidden>
                                    {
                                        tableDataToXLS.map((row, rowIndex) => {
                                            if (rowIndex === 0){
                                                return(
                                                    <tr>
                                                    {
                                                        row.map(element => {
                                                            return (<th>{element}</th>)
                                                        })
                                                    }
                                                    </tr>
                                                )
                                            }
                                            return(
                                                <tr>
                                                {
                                                    row.map(element => {
                                                        return (<td>{element}</td>)
                                                    })
                                                }
                                                </tr>
                                            )
                                        })
                                    }
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="buttons-after-padding">
                    <div className="inline-button">
                        <input
                            className="button-add-reserve"
                            type="button"
                            value={isCreate ? "Crear": "Actualizar"}
                            onClick={onSubmit}
                            disabled={eventDataErrorsStr.length > 0 || disabled}
                        />
                    </div>
                    {
                        !isCreate ?
                        <div className="inline-element horizontal-block">
                            <input
                                className="button-warning"
                                type="button"
                                value="Eliminar evento"
                                onClick={onDelete}
                                disabled={disabled}
                            />
                        </div> : <div> </div>
                    }
                </div>
                <div>
                {
                    disabled ?
                    <div>
                        <div className="text-success text-padding">
                            {
                                eventsState === CREATE_SUCCESS_STATE ?
                                "Evento creado exitosamente" :
                                eventsState === DELETED_STATE ?
                                "Evento eliminado exitosamente" : "Evento actualizado exitosamente"
                            }
                        </div>
                        <div className="text-success">{`Id del evento: ${eventId}`}</div>
                    </div> :
                    <div className="error-message">{eventDataErrorsStr}</div>
                }
                </div>
            </div>
        )
    }
}

export default EventDisplay
